var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultSquadbg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 84,
    viewBox: "0 0 67 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06139 3.36367C1.55869 16.1256 0.80577 28.9467 0.805624 41.7762C0.802556 54.5997 1.55146 67.4149 3.04934 80.1712L3.14969 81.0393L4.25348 81.1869C23.6712 83.8241 43.4372 83.8241 62.8549 81.187L63.8383 81.0534L63.9386 80.1888C66.9449 54.6481 66.9449 28.9044 63.9386 3.36368L63.8383 2.49554L62.8549 2.36198C43.401 -0.277562 23.599 -0.277563 4.1451 2.36198L3.16173 2.49553L3.06139 3.36367Z",
    fill: "#EEEEE4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultSquadbg);
export default __webpack_public_path__ + "static/media/resultSquadbg.b62cdc845b1efe48cc50cd5fc7a9c460.svg";
export { ForwardRef as ReactComponent };